import { Query } from "./interfaceHelper";
import axios from "axios";

async function  downloadCSV(name: string, url: string, query: Query, token: string) {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: query
    };

    axios.get(url, config,
        ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        }).catch(error => console.error(error));
};

export
{
    downloadCSV
}